import { Alert, Snackbar, Typography } from "@mui/material";
import { createContext, useContext, useEffect, useState } from "react";
import { useLangContext } from "./langContext";

export interface INotificationContext {
  setNotification: (
    payload: {
      type: "error" | "success" | "warning" | "info";
      message: string | string[];
    } | null
  ) => void;
}

const notificationContext = createContext<INotificationContext>({
  setNotification: () => false,
});

export function NotificationContextProvider({ ...props }: any) {
  const [notification, setNotification] = useState<{
    type: "error" | "success" | "warning" | "info";
    message: string | string[];
  } | null>(null);

  const { dir } = useLangContext();

  const handleClose = (event: any, reason: any) => {
    if (reason === "clickaway") {
      return;
    }
    setNotification(null);
  };

  return (
    <notificationContext.Provider value={{ setNotification }}>
      {props.children}
      <Snackbar
        dir={dir}
        open={!!notification}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
      >
        <Alert dir={dir} severity={notification?.type} variant="outlined">
          <>
            {typeof notification?.message == "string" ? (
              <>{notification.message}</>
            ) : (
              <>{JSON.stringify(notification?.message)}</>
            )}
          </>
        </Alert>
      </Snackbar>
    </notificationContext.Provider>
  );
}

export const useNotificationContext = () => useContext(notificationContext);
